import { useEffect, useRef, useState } from "react";
import gsap from "gsap";

export default function FullScreenVideoOverlay({ src, onFinished }) {
  const containerRef = useRef();
  const videoRef = useRef();
  // Nouvel état local pour empêcher le double fade
  const [hasFadedIn, setHasFadedIn] = useState(false);

  useEffect(() => {
    const el = containerRef.current;
    el.style.pointerEvents = "auto";

    // On ne fait fadeIn que si pas déjà fait (évite double fade)
    if (!hasFadedIn) {
      gsap.fromTo(
        el,
        { opacity: 0 },
        {
          opacity: 1,
          duration: 1,
          ease: "power2.inOut",
          onComplete: () => setHasFadedIn(true),
        }
      );
    } else {
      // Si le composant est "re-monté" (cas edge), on s'assure qu'il est bien visible
      gsap.set(el, { opacity: 1 });
    }

    const video = videoRef.current;
    video.play();

    const handleEnded = () => {
      el.style.pointerEvents = "none";
      // Un seul fadeOut, démonte APRES
      gsap.to(el, {
        opacity: 0,
        duration: 1,
        ease: "power2.inOut",
        onComplete: () => {
          setHasFadedIn(false); // pour le prochain montage
          onFinished?.();
        },
      });
    };

    video.addEventListener("ended", handleEnded);
    return () => {
      video.removeEventListener("ended", handleEnded);
      // On reset pas l'opacité ici sinon ça bug !
    };
  }, [onFinished, hasFadedIn]);

  return (
    <div
      ref={containerRef}
      style={{
        position: "fixed",
        inset: 0,
        zIndex: 9999,
        backgroundColor: "black",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        opacity: 0, // 0 par défaut, GSAP s'occupe du fade in
        pointerEvents: "none",
        transition: "none",
      }}
    >
      <video
        ref={videoRef}
        src={src}
        muted
        autoPlay
        playsInline
        style={{ width: "100%", height: "100%", objectFit: "cover" }}
      />
    </div>
  );
}
